import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from 'react';
import Home from "./pages/Home";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/AdminDashboard";
import PrivateRoute from "./admin/components/PrivateRoute";
import ProductDetail from "./pages/ProductDetail";
import ProductGallery from "./components/ProductGallery";
import ArcadePage from "./pages/ArcadePage"
import RetroContactForm from "./pages/RetroContactForm";


import { BackgroundProvider } from "./context/BackgroundContext";
import AppLayout from "./layouts/AppLayout";

export default function App() {

  return (
    <BackgroundProvider>
      <Router>
        <Routes>

          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />

          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard/>
              </PrivateRoute>
            }
          />

          {/* PUBLIC ROUTE PUBBLICHE */}
          <Route element={<AppLayout />}>

            <Route path="/" element={<Home />} />
            <Route path="/:category" element={<ProductGallery />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/arcade" element={<ArcadePage />} />
            <Route path="/contacts" element={<RetroContactForm />} />

          </Route>

        </Routes>
      </Router>
    </BackgroundProvider>
  );
}
